module.exports = __webpack_public_path__ + "static/media/ok.df5e3843.mp3";